import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOperatorDetailsDTO } from '../../../api/rooms.dao';
import Text from '../text/text';
import ColumnWithCheckbox from '../column-with-checkbox/column-with-checkbox';
import { OperatorStatus } from '../../../api/control.dao';

interface IProps {
    searchValue?: string;
    groupedOperators: { [path: string] : IOperatorDetailsDTO[]};
    withGreyedCheckMark: boolean;
    meetingId: number;
}

const GroupedOperators = (props: IProps) => {
    const { groupedOperators = {}, meetingId } = props;
    return (
        <>
            {
                Object.entries(groupedOperators).map(([operatorRole, operators]) => !!operators.length && (
                    <Fragment key={`${meetingId}` + operatorRole}>
                        {operatorRole !== 'null' && (
                            <FormattedMessage
                                id={`oe.operators.roleOptions.${operatorRole}`}
                                description='Operator role option'
                            />
                        )}
                        {operators.map((operator, i) => {
                            const fullName = operator.firstName + ' ' + operator.lastName;
                            return (

                                <ColumnWithCheckbox
                                    isActive={operator.operatorStatus === OperatorStatus.READY}
                                    key={`${meetingId}_${operatorRole}_${operator.operatorId}_${i}`}
                                    withGreyedCheckMark={props.withGreyedCheckMark}
                                >
                                    <div className='operator-list-item__text' key={operator.operatorId}>
                                        <Text message={fullName} highlightValue={props.searchValue} withEllipsis withHighlight />
                                    </div>
                                </ColumnWithCheckbox>
                            );
                        })}
                        <br/>
                    </Fragment>
                ))

            }
        </>
    );
};

export { GroupedOperators };